import Link from "@/components/ui/CcLink";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";

type CcMegaAllLinkProps = {
  href: string;
  children: ReactNode;
  className?: string;
  id?: string;
  onNavigate?: () => void;
};

export function CcMegaAllLink({
  href,
  children,
  className = "",
  id,
  onNavigate,
}: CcMegaAllLinkProps) {
  return (
    <Link
      id={id}
      href={href}
      className={`cc-nav-mega__all ${className}`.trim()}
      onNavigate={onNavigate}
    >
      {children}
      <span className="cc-nav-mega__all-arrow" aria-hidden="true">
        <ArrowRight size={16} strokeWidth={2} />
      </span>
    </Link>
  );
}

type CcMegaBackButtonProps = {
  children: ReactNode;
  className?: string;
  "aria-label"?: string;
} & Pick<ButtonHTMLAttributes<HTMLButtonElement>, "onClick">;

export const CcMegaBackButton = forwardRef<HTMLButtonElement, CcMegaBackButtonProps>(
  function CcMegaBackButton(
    { children, className = "", onClick, "aria-label": ariaLabel },
    ref,
  ) {
    return (
      <button
        ref={ref}
        type="button"
        className={`cc-nav-mega__all ${className}`.trim()}
        aria-label={ariaLabel}
        onClick={onClick}
      >
        <span
          className="cc-nav-mega__all-arrow cc-nav-mega__all-arrow--leading"
          aria-hidden="true"
        >
          <ArrowLeft size={16} strokeWidth={2} />
        </span>
        {children}
      </button>
    );
  },
);
